<template>
  <v-form ref="schoolForm" v-model="valid" class="mb-4">
    <v-text-field 
      v-model="form.schoolName" 
      label="School Name" 
      outlined 
      dense 
      prepend-inner-icon="mdi-school" 
      :rules="schoolNameRules"
      required
    /> 
    <v-text-field 
      v-model="form.schoolContact" 
      label="School Contact" 
      outlined 
      dense 
      prepend-inner-icon="mdi-phone" 
      :rules="contactRules"
      required
    />
    <v-textarea
      v-model="form.schoolAddress" 
      label="School Address" 
      outlined 
      dense 
      rows="3"
      prepend-inner-icon="mdi-map-marker" 
      :rules="addressRules"
      required
    />
    <v-text-field 
      v-model="form.principalName" 
      label="Principal Name" 
      outlined 
      dense 
      prepend-inner-icon="mdi-account-tie" 
      :rules="nameRules"
      required
    />
  </v-form>
</template>

<script setup>
import { ref } from "vue";
import { 
  nameRules,
  contactRules,
  schoolNameRules,
  addressRules
} from "@/utils/validationRule";

const props = defineProps(["form"]);
const valid = ref(false);
const schoolForm = ref(null); // Add this line

defineExpose({ 
  valid,
  validate: () => schoolForm.value.validate() // Properly expose validate
});
</script>